module.exports = __webpack_public_path__ + "media/images/point/readingToPoint-c96e97467a1855352476721642544dbe.svg";